

















































































































































































import { Vue, Component, Watch } from "vue-property-decorator";
import { vxm } from "@/store";
import Message, { MessageConverter } from "@/domain/message";
import { timeAgo } from "@/domain/message";
import Team from "@/domain/team";
import { firestore } from "@/plugins/firebase";
import { Unsubscribe, query, collection, orderBy, onSnapshot } from "@firebase/firestore";
import { endBefore, getDocs, limitToLast, startAfter, where } from "firebase/firestore";

@Component({
  filters: { timeAgo }
})
export default class Standings extends Vue {
  pageSize = 25;
  olderMessagesAvailable = false;
  loadingFirstPage = true;

  messages: (Message & { color?: string; recipients: Team[] })[] = [];
  messagesSubscription: Unsubscribe | null = null;

  sendMessageText = "";

  deleteMessageDialog = false;
  deleteMessageTarget: Message | null = null;

  selectedTeams = [];

  get fluid() {
    return vxm.app.fluid;
  }

  get publicResults() {
    return vxm.results.game.publicResults.includes("chat") || vxm.results.isInstructor;
  }

  get teams() {
    return vxm.results.teams;
  }

  get isInstructor() {
    return vxm.results.isInstructor;
  }

  deleteMessage(message: Message) {
    this.deleteMessageTarget = message;
    this.deleteMessageDialog = true;
  }

  async confirmDeleteMessage() {
    if (this.deleteMessageTarget) {
      this.messages = this.messages.filter(m => m.id !== this.deleteMessageTarget!.id);
      this.deleteMessageDialog = false;
      await vxm.results.deleteMessage(this.deleteMessageTarget.id);
    }
  }

  sendMessage() {
    if (!this.sendMessageText) {
      return;
    }

    vxm.results.sendChatMessage({
      text: this.sendMessageText,
      // selectedTeams can contain undefined, looks like a Vuetify bug
      privateTeamIds: this.selectedTeams.length ? this.selectedTeams.filter(teamId => !!teamId) : null
    });

    this.sendMessageText = "";
  }

  scrollToBottom() {
    setTimeout(() => {
      this.$vuetify.goTo(document.body.scrollHeight);
    });
  }

  mapMessage(message: Message) {
    const team = message.fromTeamId ? vxm.results.teamsById[message.fromTeamId] : undefined;

    return {
      ...message,
      color: team?.color,
      recipients: message.privateTeamIds ? message.privateTeamIds.map(id => vxm.results.teamsById[id]).filter(team => !!team) : []
    };
  }

  async loadPage() {
    const converter = new MessageConverter();
    const q = query(
      collection(firestore, `events/${vxm.results.eventId}/messages`),
      where("type", "in", ["WEB", "CHAT"]),
      orderBy("time"),
      limitToLast(this.pageSize),
      endBefore(this.messages.length ? this.messages[0].time : new Date())
    ).withConverter(converter);

    const snapshot = await getDocs(q);
    const messages = snapshot.docs.map(d => this.mapMessage(d.data()));

    this.messages = [...messages, ...this.messages];
    this.olderMessagesAvailable = messages.length === this.pageSize;
  }

  async mounted() {
    // Load first page of messages
    await this.loadPage();
    this.loadingFirstPage = false;
    this.scrollToBottom();

    // Subscribe to new messages
    const converter = new MessageConverter();
    const q = query(
      collection(firestore, `events/${vxm.results.eventId}/messages`),
      where("type", "in", ["WEB", "CHAT"]),
      orderBy("time"),
      startAfter(this.messages.length ? this.messages[this.messages.length - 1].time : new Date())
    ).withConverter(converter);

    this.messagesSubscription = onSnapshot(q, snapshot => {
      const newMessages = snapshot
        .docChanges()
        .filter(change => change.type === "added")
        .map(change => this.mapMessage(change.doc.data()));

      if (newMessages.length) {
        this.messages = [...this.messages, ...newMessages];
        this.scrollToBottom();
      }
    });
  }

  destroyed() {
    if (this.messagesSubscription) {
      this.messagesSubscription();
    }
  }
}
